import { FC } from 'react'
import { IExtract } from '../../../../../modules/consume/domain/models/Extract'
import { moneyMaskNumber } from '../../../../../services/utils/Money';
import styles from './ExtractOrders.module.scss'
import { Button } from '@mui/material';
import { Print } from '@mui/icons-material';
import { useI18n } from '../../../../../hooks/useI18n';
export interface IExtracOrdersProps {
    //propertys
    extract: IExtract;
    hideResume?: boolean;
    printExtract?: () => Promise<void>;
}
    

const ExtractOrders: FC<IExtracOrdersProps> = ({ extract, hideResume, printExtract }) => {
    const { t } = useI18n();
    
    return (
        <div id={styles.ExtractOrders} >
            <div className={styles.container}>
                <div className={styles.containerOrder}>
                    {extract.orders.map((item) => item.number)}
                    {extract.orders.map(order => (
                        <div key={order.id} className={styles.orderContent}>
                            <span className={styles.textData}>{new Date(order.createdAt + "z").toLocaleString('pt-BR')}</span>
                            {order.items.map(orderItem => (
                                <div key={orderItem.id} className={styles.orderItemContainer} style={{ textDecoration: (orderItem.isCanceled || orderItem.isTransfered) ? "line-through" : 'unset' }}>
                                    <div className={styles.orderItemHeader}>
                                        <span className={styles.label} style={{ opacity: (orderItem.isCanceled || orderItem.isTransfered) ? 0.3 : 1 }}>
                                            {orderItem.quantity}x {orderItem.name} {orderItem.isCanceled && `(${t('modals.extract.canceled')})`} {orderItem.isTransfered && `(${t('modals.extract.transferred')})`}
                                        </span>
                                        <span className={styles.value}>{moneyMaskNumber(orderItem.quantity * orderItem.totalValue)}</span>
                                    </div>
                                    {
                                        !!orderItem?.additionals?.length && <div className={styles.additionalsContainer}>
                                            {orderItem.additionals.map((additional, index) => (
                                                <div key={index} className={styles.contentAddicional}>
                                                    <label className={styles.text} >{additional.name}</label>
                                                    <div>
                                                        {additional.items.map((additionalItems, _index) => (
                                                            <div key={_index} className={styles.contentAddicionalItem}>
                                                                <span className={styles.text}>
                                                                    {additionalItems.quantity}x {additionalItems.name}
                                                                </span>
                                                                <p className={styles.text}>
                                                                    {moneyMaskNumber(additionalItems.unitValue * additionalItems.quantity)}
                                                                </p>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            ))}
                                            <div>
                                                {orderItem.observations.map(observations => (
                                                    <div key={observations.question} className={styles.contentAddicional}>
                                                        <label className={styles.text}>{observations.question}</label>
                                                        <p className={styles.text}>-{observations.response}</p>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>}

                                </div>
                            ))}
                            <div className={styles.orderTotal}>
                                <label>{t('modals.extract.total')}</label>
                                <label>{moneyMaskNumber(order.totalAmount)}</label>
                            </div>
                        </div>
                    ))}
                </div>

                {!hideResume && (
                    <div className={styles.resumeContainer}>
                        {printExtract && <Button className={styles.printButton} size='small' onClick={printExtract} startIcon={<Print />}>{t('modals.extract.print')}</Button>}
                        <div className={styles.contentResume}>
                            <p className={styles.label}>{t('modals.extract.totalConsumed')}:</p>
                            <p className={styles.value}>{moneyMaskNumber(extract.totalAmount)}</p>
                        </div>
                        {!!extract.paidAmount && (
                            <div className={styles.contentResume}>
                                <p className={styles.label}>{t('modals.extract.totalPaid')}:</p>
                                <p className={styles.value}>{moneyMaskNumber(extract.paidAmount)}</p>
                            </div>
                        )}
                        {extract.serviceFeeConfig.serviceFeePercentage > 0 ? (
                            <>
                                <div className={styles.contentResume}>
                                    <p className={styles.label}>
                                        {t('modals.extract.serviceFee')} ({extract.serviceFeeConfig.serviceFeePercentage * 100}%):
                                    </p>
                                    <p className={styles.value}>{moneyMaskNumber(extract.serviceFeeConfig.serviceFeeAmount)}</p>
                                </div>
                                <div className={styles.contentResume}>
                                    <p className={styles.labelTotal}>{t('modals.extract.totalToPay')}:</p>
                                    <p className={styles.valueTotal}>{moneyMaskNumber(extract.totalToPayWithFee)}</p>
                                </div>
                            </>
                        ) : (
                            <div className={styles.contentResume}>
                                <p className={styles.labelTotal}>{t('modals.extract.totalToPay')}</p>
                                <p className={styles.valueTotal}>{moneyMaskNumber(extract.totalToPayWithFee)}</p>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}
export default ExtractOrders